import LogoHR from '@CS/assets/logo-hr.png';
import LogoEN from '@CS/assets/logo-en.png';

export default {
  text: {
    hr: 'Prijavi se svojim McDonald’s računom i pripremi se za Golden Getaway!',
    en: 'Log in with your McDonald’s account and get set for a fun getaway..'
  },

  button: {
    hr: 'Prijavi se',
    en: 'Log in'
  },

  logo: {
    hr: LogoHR,
    en: LogoEN
  }
};
